import {
  MAP_CONTEXT_MENU,
  MAP_LOADED,
  RESET_CURRENT_TARGET,
  SET_CURRENT_TARGET,
  SET_CURRENT_TARGET_CHILDREN,
  SET_CURRENT_TARGET_INTERSECT_LAYERS,
  SET_CURRENT_TARGET_WHATS_HERE,
  SET_MAP_X,
  SET_MAP_Y,
  SET_MAP_Z
} from './actions'

export const currentTarget = (state = null, action) => {
  switch (action.type) {
    case SET_CURRENT_TARGET:
      return action.currentTarget
    case RESET_CURRENT_TARGET:
      return null
    default:
      return state
  }
}

export const currentTargetWhatsHere = (state = null, action) => {
  switch (action.type) {
    case SET_CURRENT_TARGET_WHATS_HERE:
      return action.currentTarget
    default:
      return state
  }
}

export const currentTargetChildren = (state = null, action) => {
  switch (action.type) {
    case SET_CURRENT_TARGET_CHILDREN:
      return action.currentTargetChildren
    default:
      return state
  }
}

export const currentTargetIntersectLayers = (state = null, action) => {
  switch (action.type) {
    case SET_CURRENT_TARGET_INTERSECT_LAYERS:
      return action.currentTargetIntersectLayers
    default:
      return state
  }
}

export const bMapLoaded = (state = null, action) => {
  switch (action.type) {
    case MAP_LOADED:
      return action.bMapLoaded
    default:
      return state
  }
}

export const mapContextMenu = (state = null, action) => {
  switch (action.type) {
    case MAP_CONTEXT_MENU:
      return action.contextMenu
    default:
      return state
  }
}

export const mapX = (state = null, action) => {
  switch (action.type) {
    case SET_MAP_X:
      return action.x
    default:
      return state
  }
}

export const mapY = (state = null, action) => {
  switch (action.type) {
    case SET_MAP_Y:
      return action.y
    default:
      return state
  }
}

export const mapZ = (state = null, action) => {
  switch (action.type) {
    case SET_MAP_Z:
      return action.z
    default:
      return state
  }
}
